import { Box, Image, List, ListItem, Text } from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import { messages } from '../../messages';
import { HowToChooseSize as HowToChooseProps } from '../../types';
import { getTranslatedMessage } from '../../utils/dataHelpers';

import styles from './HowToChoose.module.scss';

export const HowToChoose = ({ imageUrl, instructions }: HowToChooseProps) => {
  const intl = useIntl();

  return (
    <>
      <Text type="display5" element="h3">
        {intl.formatMessage(messages.howToChoose)}
      </Text>

      <Box className={styles.howToChooseContent}>
        <Box
          display="flex"
          justifyContent="center"
          paddingBottom="s"
          paddingLeft="s"
        >
          <Image src={imageUrl} alt="" width={220} />
        </Box>

        <Box>
          <List ordered>
            {instructions.map((instruction, i) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: noArrayIndexKey
              <ListItem key={i}>
                <Text type="body2">
                  {getTranslatedMessage(instruction, intl)}
                </Text>
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>
    </>
  );
};
